import React from 'react';
import { renderList } from 'utils/async-list';
import { Column } from 'react-virtualized';

export const list = () => {
  const rowClickedUrl = id => '';
  const loadNextUrl = '/customer/aast-reports.json';

  renderList(rowClickedUrl, loadNextUrl, renderColumns, {
    rowHeight: 60,
  });
};

const renderAction = ({ rowData }) => {
  const id = rowData.id;

  return (
    <div>
      <a
        href={`/customer/aast-reports/${id}/pdf`}
        target="_blank"
        className="ui basic button"
      >
        <i className="file pdf outline icon" />
        PDF
      </a>
    </div>
  );
};

function renderColumns(width) {
  return [
    <Column
      key="file_id"
      dataKey="file_id"
      width={(width / 16) * 2}
      cellRenderer={renderAction}
      disableSort
      label="Action"
    />,
    <Column
      key="case_name"
      dataKey="case_name"
      width={(width / 16) * 6}
      label="Chantier"
    />,
    <Column key="name" dataKey="name" width={(width / 16) * 6} label="Nom" />,
    <Column key="date" dataKey="date" width={(width / 16) * 2} label="Date" />,
  ];
}



// WEBPACK FOOTER //
// ./src/modules/customer/aast-reports.js